import { render, staticRenderFns } from "./DataInputInteger.vue?vue&type=template&id=cb92efc0&"
import script from "./DataInputInteger.vue?vue&type=script&lang=js&"
export * from "./DataInputInteger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports